import styled from "@emotion/styled";
import { fontRobotoCondensed } from "@product/scmp-sdk";

import { BaseLink } from "shared/components/common/base-link";

export const Container = styled.div``;
export const Label = styled.div`
  margin-block-end: 4px;

  color: rgb(255, 202, 5);
  font-weight: 700;
  font-size: 12px;
  line-height: 16.8px;
  text-transform: uppercase;
`;

export const Children = styled.div``;
export const Item = styled(BaseLink)`
  display: flex;
  gap: 12px;
  align-items: center;

  padding-block: 12px;
  border-block-end: 1px solid rgba(161, 161, 161, 0.3);
`;

export const YellowDot = styled.span`
  inline-size: 12px;
  block-size: 12px;

  border-radius: 50%;

  background-color: rgb(255, 202, 5);
`;

export const ItemText = styled.span`
  flex: 1;

  color: #ffffff;
  font-size: 16px;
  line-height: 19.2px;
`;

export const NewTag = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  inline-size: 30px;
  block-size: 21px;

  color: #ffffff;
  font-weight: 700;
  font-size: 14px;
  font-family: ${fontRobotoCondensed};
  line-height: 14px;

  border-radius: 2px;

  background-color: #e84254;
`;
